import React, { Component } from 'react';
import {
	Route,
	Switch,
} from 'react-router-dom';

import HomePage from './home/HomePage';
import AboutPage from './about/AboutPage';
import PetitionPage from './petition/PetitionPage';

import NotFound from './error/NotFound';

class Routes extends Component {
	render() {
		return (
            <Switch>
				<Route exact path="/" component={HomePage} />
				<Route exact path="/om" component={AboutPage} />
				{/* <Route exact path="/namninsamling" component={PetitionPage} /> */}

                <Route component={NotFound} />
            </Switch>
		);
	}
}

// const PrivateRoute = ({ component: Component, ...rest }) => (
// 	<Route {...rest} render={props => (
// 		auth.isAuthenticated ? (
// 			<Component {...props} />
// 		) : (
// 			<Redirect to={{
// 				pathname: '/login',
// 				state: { from: props.location }
// 			}} />
// 		)
// 	)} />
// );

// const LoginRoute = ({ component: Component, ...rest }) => (
// 	<Route {...rest} render={props => (
// 		auth.isAuthenticated ? (
// 			<Redirect to={{
// 				pathname: '/',
// 				state: { from: props.location }
// 			}} />
// 		) : (
// 			<Component {...props} />
// 		)
// 	)} />
// );

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js